<template>
  <div>
    <div class="page-title">New UGC Submission</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="create"
      btnText="Add UGC Submission"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.submission.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Submission.new({
        submission_form_id: this.$route.params.submissionFormId,
      });
      this.form = data;
    },
    async create() {
      await this.$api.Submission.create(this.form);
      this.$router.push("/widgets/submission-forms");
    },
  },
};
</script>

<style></style>
